import { render, staticRenderFns } from "./TheAppShell.vue?vue&type=template&id=bd54670a&scoped=true"
import script from "./TheAppShell.vue?vue&type=script&lang=ts"
export * from "./TheAppShell.vue?vue&type=script&lang=ts"
import style0 from "./TheAppShell.vue?vue&type=style&index=0&id=bd54670a&prod&scoped=true&lang=css"
import style1 from "./TheAppShell.vue?vue&type=style&index=1&id=bd54670a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd54670a",
  null
  
)

export default component.exports